module.exports = __webpack_public_path__ + "static/assets/774c7d89f540ef070b50361925a794d0.png";